import React from 'react';

export default function FormGrid({ children }) {
  return (
    <div className="sm:grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 mb-4 sm:gap-4 items-center">
      {children}
    </div>
  );
}
